import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import Logo from '../assets/logo.png';
import Logo1 from '../assets/logo1.png';
import Dashboard from '../assets/icons/Dashboard_24px.png';
import Campaign from '../assets/icons/Campaign_24px.png';
import ShortListed from '../assets/icons/Shortlist_24px.png';
import ActivityLogSvg from '../assets/icons/ActivityLog_24px.png';
import ArrowLeft from '../assets/icons/arrowLeft.png';
import ArrowRight from '../assets/icons/arrowRight.png';
import userAvtar from '../assets/icons/Avatar.png';
import Logo2 from '../assets/logo2.jpg';
import Creators from '../assets/icons/creative.png';
// import Campaign from '../assets/icons/marketing.png';
// import ShortListed from '../assets/icons/shortlist.png';
// import ActivityLogSvg from '../assets/icons/history-icon.svg';
// import ArrowLeft from '../assets/icons/angle-left-icon.svg';
// import ArrowRight from '../assets/icons/angle-right-icon.svg';
import AIBot from '../assets/icons/ai-chatting.svg'
import '../styles/SideMenu.css';
import { useAuth } from '../contexts/AuthContext';

const SideMenu = ({ isAdmin }) => {
  const { userRole, username, isCollapsed, setIsCollapsedValue } = useAuth();
  const location = useLocation();
  const activeKey = location.pathname;

  const handleCollapse = () => {
    setIsCollapsedValue(!isCollapsed);
  };

  const menuItems = [
    {
      path: '/dashboard',
      icon: Dashboard,
      label: 'Dashboard',
    },
    {
      path: '/campaigns',
      icon: Campaign,
      label: 'Campaign',
    },
    {
      path: '/shortlisted',
      icon: ShortListed,
      label: 'Shortlisted',
    },
    {
      path: '/support',
      icon: AIBot,
      label: 'SocialJet GPT',
    },
  ];

  if (userRole === 'Administrator') {
    menuItems.push({
      path: '/activitylog',
      icon: ActivityLogSvg,
      label: 'Activity Log',
    });
  }

  return (
    <aside className={`side-menu ${isCollapsed ? 'collapsed' : 'expanded'}`}>
      {/* Logo Header */}
      <div className={`menu-header ${isCollapsed ? 'menu-column-header' : 'mt-3'}`}>
        <NavLink to="/" aria-label="Site Logo">
          {isCollapsed ? (
              <img src={Logo1} alt="Menu Logo" className="logo-small" />
          ) : (
            <img src={Logo} alt="Menu Logo" className="logo-large ms-2" />
          )}
        </NavLink>
        {!isCollapsed &&
        <div className={`collapse-btns ${isCollapsed ? 'collapsed d-none' : ''}`}>
          <button onClick={handleCollapse} className="collapse-btn">
            <img
              src={isCollapsed ? ArrowRight : ArrowLeft}
              alt={isCollapsed ? 'Expand' : 'Collapse'}
              className="collapse-icon"
            />
          </button>
        </div>
}
      </div>

      <hr className=''/>
      <div className={`collapse-btns d-flex justify-content-center ${!isCollapsed ? 'd-none' : ''}`}>
          <button onClick={handleCollapse} className="collapse-btn">
            <img
              src={isCollapsed ? ArrowRight : ArrowLeft}
              alt={isCollapsed ? 'Expand' : 'Collapse'}
              className="collapse-icon"
            />
          </button>
      </div>
      {/* Navigation Items */}
      <div className="menu-content">
        <Nav className="menu-nav" activeKey={activeKey}>
          {menuItems.map(({ path, icon, label }) => (
            <Nav.Link
              as={NavLink}
              to={path}
              key={path}
              eventKey={path}
              className={`menu-item ${isCollapsed ? 'collapsed' : ''}`}
            >
              <img src={icon} alt={`${label} Icon`} className="menu-icon" />
              {!isCollapsed && <span className="menu-text">{label}</span>}
            </Nav.Link>
          ))}
        </Nav>
      </div>

      {/* User Info Section */}
      <div className={`user-profile ${isCollapsed ? 'collapsed' : ''}`}>
        <img src={userAvtar} alt="User Avatar" className="user-avatar" />
        {!isCollapsed && (
          <>
            <div className="user-details">
              <p className="user-name">{username}</p>
              <p className="user-role">{userRole}</p>
            </div>
            <span className="user-menu">⋮</span>
          </>
        )}
      </div>
    </aside>
  );
};

export default SideMenu;
